"use client";

import React from "react";
import { GlassPanel } from "./GlassPanel";
import { SectionHeading } from "./SectionHeading";
import { cn } from "@/lib/utils";

type GlassSectionProps = {
  title?: React.ReactNode;
  level?: 1 | 2 | 3 | 4;
  actions?: React.ReactNode;
  className?: string;
  align?: "left" | "center";
  headingClassName?: string;
  panelVariant?: "glass" | "solid" | "transparent";
  children: React.ReactNode;
};

export function GlassSection({
  title,
  level = 2,
  actions,
  className,
  align = "left",
  headingClassName,
  panelVariant = "glass",
  children,
}: GlassSectionProps) {
  return (
    <GlassPanel className={cn("p-4 md:p-6 space-y-4", className)} variant={panelVariant}>
      {title ? (
        <div className={cn(
          actions ? "flex items-center justify-between" : "",
          !actions && align === "center" ? "flex items-center justify-center" : undefined,
        )}>
          <SectionHeading level={level} align={align} className={headingClassName}>{title}</SectionHeading>
          {actions}
        </div>
      ) : null}
      {children}
    </GlassPanel>
  );
}

export default GlassSection;


